module.exports = __webpack_public_path__ + "static/media/mendes.c700fa14.jpg";